import React from 'react';
import { Stack } from "@mui/material";
import { Stats } from './Stats';
import { Calendar } from './Calendar';

function Header( {user, checkins, loadingCheckins } ) {

    const currentDate = new Date();
    const options = { weekday: 'short', month: 'short', day: 'numeric' };
    const formattedDate = currentDate.toLocaleDateString('en-US', options);

    return (
        <Stack
            direction={'row'}
            justifyContent={'space-between'}
            sx={{
                paddingBottom: '20px',
            }}
        >
            <Stack>
                <span

                    className="app-font-fancy"
                    style={{
                        color: '#3f0300',
                        fontSize: '2.8rem',
                        fontWeight: '700',
                    }}
                >
                    Hi, {user.given_name}
                </span>
                <span
                    className="app-font-fancy"
                    style={{
                        color: '#3f0300',
                        fontSize: '2.2rem',
                        fontWeight: '600',
                    }}
                >
                    {formattedDate}
                </span>
            </Stack>
            <Stack
                direction={'row'}
                spacing={2}
            >
                <Stats />
                <Calendar checkins={checkins} loadingCheckins={loadingCheckins} />
            </Stack>
        </Stack>
    )
}

export { Header };